import * as React from 'react';
import { Grid, FormControl, Select, InputLabel, MenuItem, Typography, Box, Button } from '@mui/material';
import OutlinedInput from '@mui/material/OutlinedInput';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import styles from './creativeAssets.module.scss'
import Paper from '../../../components/Paper';

const assets = [1, 2]

const CreativeAssets = ({ state, setters, handlers, showSummary }) => {

  return (
    <Paper>
      <Grid container xs={12} className={styles.creativeAssetsContainer} justifyContent="space-between" alignItems="baseline">
        {assets.map(item => <Grid container xs={6}>
          <Box className={styles.asset}>
            <Grid item xs={12}>
              <Typography className={styles.label}>Creative Asset 1</Typography>
            </Grid>
            <Box className={styles.box}>
              <Grid container item xs={12} justifyContent="space-between">
                <Grid item xs={6}>
                  Type of Creative: PN
                </Grid>
                <Grid item xs={6} textAlign="right">
                  Image Link: <a href='#'>Copy</a>
                </Grid>
              </Grid>
              <Grid className={styles.img} item xs={12}>
                <img />
              </Grid>
              <Grid className={styles.btnContainer} container item xs={12} justifyContent="space-around">
                <Grid item xs={5}>
                  <Button className={styles.button} variant='outlined'>Approve</Button>
                </Grid>
                <Grid item xs={5}>
                  <Button className={`${styles.button} ${styles.btnGray}`} variant='outlined' color='secondary'>̃Notify Creative</Button>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Grid>)}
      </Grid>
      <Grid container className={styles.creativeAssetsFooter} justifyContent="right">
        <Grid item xs={4} >
          <Button className={styles.button} variant='outlined' onClick={() => {
            showSummary(true)
          }}>Preview Campaign</Button>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default CreativeAssets
